import React from "react";
export const assetHealthArc = {
  colorArray: ["#E20C18", "#FFE80F", "#9ADE55"],
  subArcs: [{ length: 0.6 }, { length: 0.2 }, { length: 0.2 }],
  padding: 0.01,
  width: 0.3,
};
export const assetHealthPointer = {
  elastic: true,
  animationDelay: 0,
  color: "black",
  width: 18,
  length: 0.6,
};
export const assetHealthStyle = {
  width: "240px",
  height: "183px",
};
export const assetHealthStatusData = [
  { status: "Level 1 (80%-100%)", color: "#9ADE55" },
  { status: "Level 2 (60%-80%)", color: "#FFE80F" },
  { status: "Level 3 (< 60%)", color: "#E20C18" },
];

export const preventiveMaintenanceDataStatusData = [
  { status: "Scheduled", color: "#0082C3" },
  { status: "Venodr Accepted", color: "#004876" },
  { status: "Vendor Rescheduled", color: "#E20C18" },
  { status: "SOM Rescheduled", color: "#FFE80F" },
  { status: "Partial", color: "#844F38" },
  { status: "Completed", color: "#DAEF8F" },
];

export const tpvstatusData = [
  { status: "Open", color: "#E20C18" },
  { status: "Closed", color: "#DAEF8F" },
  { status: "Total", color: "#0082C3" },
];
export const incidentBarStatusData = [
  { status: "Open", color: "#E20C18" },
  { status: "Closed", color: "#FFE80F" },
];
export const IncidentDoughnutStatusData = [
  { status: "Level 1", color: "#004876" },
  { status: "Level 2", color: "#844F38" },
  { status: "Level 3", color: "#EC6607" },
  { status: "Level 4", color: "#FFE80F" },
];
export const workRequestStatusData = [
  { status: "Open", color: "#EC6607" },
  { status: "Closed", color: "#004876" },
];

export const tpvDataLabels = ["High", "Medium", "Low"];
export const incidentBarlabels = ["Level 1", "Level 2", "Level 3", "Level 4"];

export const assetHealthScore = [
  { id: 1, label: "Asset Health Alert Score" },
  { id: 2, label: "Preventive Maintenance Score" },
  { id: 3, label: "Third Party Audit Score" },
  { id: 4, label: "Maintenance Incident Score" },
  { id: 5, label: "Maintenance Work Request Score" },
];
export const preventiveMetaDataFirst = [
  { id: 1, label: "Quater Update" },
  // { id: 2, label: "Date:" },
  { id: 3, label: "Open Preventive:" },
  { id: 3, label: "Closed Preventive:" },
  { id: 4, label: "Status:" },
];
export const preventiveMetaDataSecond = [
  { id: 1, label: "Total YTD" },
  { id: 2, label: "Planned Status:" },
  { id: 3, label: "Realised Status:" },
];
export const tpvMetaDataFirst = [
  { id: 1, label: "Total YTD" },
  { id: 2, label: "Total TPV NC:" },
];
export const tpvMetaDataSecond = [
  { id: 1, label: "TPV High Alert Points" },
  { id: 2, label: "Closed High Alert Points" },
  { id: 3, label: "Closure Percentage" },
];
export const tpvMetaDataThird = [
  { id: 1, label: "Total TPV Alert Points" },
  { id: 2, label: "Closed TPV NC:" },
  { id: 3, label: "Closure Percentage" },
];
export const incidentMetaDataFirst = [
  { id: 1, label: "Total YTD" },
  { id: 2, label: "Total Open:" },
  { id: 3, label: "Total Closed:" },
  { id: 4, label: "Closure Percentage" },
];
export const incidentMetaDataSecond = [
  { id: 1, label: "Total Incidents" },
  { id: 2, label: "Level 1 incidents" },
  { id: 3, label: "Level 2 incidents" },
  { id: 4, label: "Level 3 incidents" },
  { id: 5, label: "Level 4 incidents" },
];
export const workRequestMetaData = [
  { id: 1, label: "Total YTD" },
  { id: 2, label: "Planned Status:" },
  { id: 3, label: "Realised Status:" },
];
export const workRequestMetaDataFirst = [
  { id: 1, label: "Month" },
  { id: 2, label: "Open Request:" },
  { id: 3, label: "Closed Request:" },
  { id: 4, label: "Status" },
];
export const barOptions = {
  responsive: true,

  plugins: {
    datalabels: {
      display: false,
    },
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        drawBorder: false,
        display: false,
      },
    },
    y: {
      ticks: {
        beginAtZero: true,
      },
      grid: {
        drawBorder: false,
        display: false,
      },
    },
  },
  maintainAspectRatio: false,
  cutoutPercentage: 70,
};
export const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,

  plugins: {
    datalabels: {
      display: false,
    },
    legend: {
      display: false,
    },
    textInside: true,
  },

  cutoutPercentage: 60,
};
export const NCScoreCellColor = {
  close: "rgb(165 205 20)",
  open: "rgb(247 146 136)",
};
export const NCTableColumns = [
  {
    title: "SL No.",
    dataIndex: "slNo",
    width: 50,
    render: (text, record, index) => {
      return index + 1; // Adding 1 to index to start from 1 instead of 0
    },
  },
  {
    title: "Store Name",
    dataIndex: "storeName",
    key: "storeName",
    width: 100,
  },
  {
    title: "Auditor Name",
    dataIndex: "auditorName",
    key: "auditorName",
    width: 100,
  },
  {
    title: "Project Scopes",
    dataIndex: "projectScopeName",
    key: "projectScopeName",
    width: 100,
  },
  {
    title: "Alert Level",
    dataIndex: "alertLevel",
    key: "alertLevel",
    width: 100,
    render: (text, record, index) => {
      return {
        props: {
          style: {
            background:
              NCScoreCellColor[record.storeClosureUpdate?.toLowerCase()],
          },
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: "Alert Point",
    dataIndex: "alertPoint",
    key: "alertPoint",
    width: 200,
    render: (text, record, index) => {
      return <span>{text}</span>;
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 200,
  },
  {
    title: "Solution",
    dataIndex: "solution",
    key: "solution",
    width: 200,
  },
  {
    title: (
      <div
        className="text-center"
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexDirection: "column",
        }}
      >
        <div>Store Closure Update</div>
      </div>
    ),
    dataIndex: "storeClosureUpdate",
    key: "storeClosureUpdate",
    width: 100,
    render: (text, record, index) => {
      return <span>{text}</span>;
    },
  },
  {
    title: "Store Closure Comment",
    dataIndex: "storeClosureComment",
    key: "storeClosureComment",
    width: 200,
    render: (text, record, index) => {
      return <span>{text}</span>;
    },
  },
];

const generateColumns = (columnsConfig) => {
  return columnsConfig.map((col) => {
    if (col.dataIndex === "S.No") {
      return {
        ...col,
        render: (text, record, index) => index + 1,
      };
    }
    return col;
  });
};
const incidentColumnsConfig = [
  { title: "S.No", dataIndex: "S.No", key: "S.No" },
  { title: "Incident Date", dataIndex: "incidentDate", key: "incidentDate" },
  { title: "Store", dataIndex: "storeName", key: "storeName" },
  { title: "Alert Level", dataIndex: "alertLevel", key: "alertLevel" },
  {
    title: "Incident Created By",
    dataIndex: "incidentCreatedBy",
    key: "incidentCreatedBy",
  },
  {
    title: "Incident Created Date",
    dataIndex: "incidentCreatedDate",
    key: "incidentCreatedDate",
  },
  {
    title: "Incident Closed Date",
    dataIndex: "incidentClosedDate",
    key: "incidentClosedDate",
  },
  {
    title: "Incident Status",
    dataIndex: "incidentStatus",
    key: "incidentStatus",
  },
];

const workRequestColumnsConfig = [
  { title: "S.No", dataIndex: "S.No", key: "S.No" },
  { title: "Work Request Id", dataIndex: "id", key: "Work Request Id" },
  { title: "Asset Name", dataIndex: "assetName", key: "Asset Name" },
  { title: "Store Name", dataIndex: "storeName", key: "Store Name" },
  { title: "Priority", dataIndex: "workRequestPriority", key: "Priority" },
  { title: "Start Date", dataIndex: "workRequestStartDate", key: "Start Date" },
  { title: "Created Date", dataIndex: "createdOn", key: "Created Date" },
  { title: "Created By", dataIndex: "createdBy", key: "Created By" },
  {
    title: "Description",
    dataIndex: "workRequestDescription",
    key: "Description",
  },
  { title: "Status", dataIndex: "workRequestStatusDesc", key: "Status" },
];
export const Incidentcolumns = generateColumns(incidentColumnsConfig);
export const WorkRequestcolumns = generateColumns(workRequestColumnsConfig);

export const doughnutChartCenterValue = (totalText) => ({
  id: "textCenter",
  beforeDatasetsDraw(chart, args, pluginOptions) {
    const { ctx, data } = chart;
    ctx.save();

    const centerX = chart.width / 2;
    const centerY = chart.height / 2;

    const containerHeight = 40;
    const containerY = centerY - containerHeight / 2;

    // Set up flex properties
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Draw calculated value
    const totalValue =
      data?.datasets[0]?.data?.reduce(
        (acc, currentValue) => acc + currentValue,
        0
      ) ?? 0;
    const totalValueText = `${totalValue}`;
    const totalValueY = containerY + 12;
    ctx.font = "400 32px sans-serif";
    ctx.fillStyle = "black";
    ctx.fillText(totalValueText, centerX, totalValueY);

    // Draw a space
    const spaceText = " ";
    const spaceY = totalValueY + 12;
    ctx.fillText(spaceText, centerX, spaceY);

    // Draw the dynamic total text
    const totalY = spaceY + 12;
    ctx.font = "10px sans-serif";
    ctx.fillStyle = "grey";
    ctx.fillText(totalText, centerX, totalY);

    ctx.restore();
  },
});

export const renderStatusData = (data) => {
  return data.map((item, index) => (
    <p key={index}>
      <span style={{ backgroundColor: item.color }}></span>
      {item.status}
    </p>
  ));
};
export const filterData = (formattedIncidentData, alertLevel, alertType) =>
  formattedIncidentData
    .filter(
      (item) =>
        item.alertLevel === alertLevel && item.incidentUpdate === alertType
    )
    .map((item) => item.total);

export const renderItemsWithLabelClass = (items, commonLabel) => {
  return items.map((item) => (
    <span
      key={item.id}
      className={
        item.label === commonLabel || item.label === "Closure Percentage"
          ? "quater-update-heading"
          : ""
      }
    >
      {item.label}
    </span>
  ));
};
export const filterOptionData = (input, option) => {
  return option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
};
export const commonPlugins = {
  datalabels: {
    display: true,
    align: "center",
    color: "black",
    // anchor: "end",
    formatter: function (value, context) {
      return value === 0 ? "" : value;
    },
    anchor: function (context) {
      return context.dataset.data[context.dataIndex] === 0 ? "start" : "center";
    },
    font: {
      weight: "500",
    },
  },
  legend: {
    display: false,
  },
};
export const doughnutcommonPlugins = {
  datalabels: {
    display: true,
    color: "black",
    formatter: function (value, context) {
      return value === 0 ? "" : value;
    },
  },
  legend: {
    display: false,
  },
};

const alertMapping = {
  "00": { alertType: "OPEN", alertLevel: "HIGH" },
  "01": { alertType: "CLOSE", alertLevel: "HIGH" },
  "02": { alertType: "TOTAL", alertLevel: "HIGH" },
  10: { alertType: "OPEN", alertLevel: "MEDIUM" },
  11: { alertType: "CLOSE", alertLevel: "MEDIUM" },
  12: { alertType: "TOTAL", alertLevel: "MEDIUM" },
  20: { alertType: "OPEN", alertLevel: "LOW" },
  21: { alertType: "CLOSE", alertLevel: "LOW" },
  22: { alertType: "TOTAL", alertLevel: "LOW" },
};

export const handleBarClick =
  (searchedItem, dispatch, fetchTpvData, _doOpenTpvModal) =>
  (event, elements) => {
    if (elements.length <= 0) return;
    // Extracting information about the clicked bar
    const clickedElement = elements[0];
    const barCoordinates =
      String(clickedElement?.index) + String(clickedElement?.datasetIndex);
    console.log(barCoordinates);

    const { alertType, alertLevel } = alertMapping[barCoordinates] || {};

    if (!alertType || !alertLevel) return;
    const store = String(searchedItem?.storeId || "");
    const month = searchedItem?.currentMonth || "";
    const year = searchedItem?.currentYear || "";
    dispatch(fetchTpvData(alertType, alertLevel, store, month, year));
    _doOpenTpvModal();
  };

export function calculateYtdTotal(YtdData) {
  const parts = YtdData.split("/");
  if (parts.length === 2) {
    const dataClosed = parseFloat(parts[0]);
    const dataOpen = parseFloat(parts[1]);
    let result;
    if (dataClosed === 0 && dataOpen === 0) {
      result = 100;
    } else if (dataClosed === 0) {
      result = 0;
    } else {
      result = ((dataClosed / (dataOpen + dataClosed)) * 100).toFixed(2);
    }
    return parseFloat(result);
  }
  // Return a default value or handle invalid input as needed
  // return null;
}

export const handleChartClick = (
  chartElements,
  workRequestData,
  searchedItem,
  setModalVisible,
  setSelectedLabel,
  dispatch,
  fetchWorkRequestData
) => {
  if (chartElements && chartElements.length > 0) {
    const clickedIndex = chartElements[0].index;
    const clickedLabel = workRequestData.labels[clickedIndex];

    setSelectedLabel(clickedLabel);
    setModalVisible(true);
    const store = String(searchedItem?.storeId || "");
    const month = searchedItem?.currentMonth || "";
    const year = searchedItem?.currentYear || "";
    dispatch(fetchWorkRequestData(clickedLabel, "", store, month, year));
  }
};

export const handleIncidentChartClick = ({
  event,
  chartElements,
  incidenDoughnutData,
  setSelectedLabel,
  setModalVisible,
  searchedItem,
  dispatch,
  fetchIncidentData,
  mappedCodes,
}) => {
  if (chartElements && chartElements.length > 0) {
    const clickedIndex = chartElements[0].index;
    const clickedLabel = incidenDoughnutData.labels[clickedIndex];

    setSelectedLabel(clickedLabel);
    setModalVisible(true);
    const store = String(searchedItem?.storeId || "");
    const month = searchedItem?.currentMonth || "";
    const year = searchedItem?.currentYear || "";
    dispatch(
      fetchIncidentData("TOTAL", mappedCodes[clickedLabel], store, month, year)
    );
  }
};

export const formatDataWithCodes = (codes, data, setMappedCodesCallback) => {
  codes.sort((a, b) => a.codeId - b.codeId);

  const mapCodes = codes.reduce((acc, code, index) => {
    acc[code.codeId] = `Level ${index + 1}`;
    return acc;
  }, {});

  const reverseMapCodes = Object.entries(mapCodes).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {}
  );

  if (setMappedCodesCallback) {
    setMappedCodesCallback(reverseMapCodes);
  }

  return data.map((item) => {
    const codeValue = codes.find(
      (codeData) => codeData.codeId === item.alertLevel
    );
    return codeValue
      ? { ...item, alertLevel: mapCodes[codeValue.codeId] }
      : item;
  });
};

export const calculateIncidentScore = (
  levelOneClose,
  levelTwoClose,
  levelThreeClose,
  levelFourClose,
  incidentTotalCount
) => {
  if (incidentTotalCount === 0) {
    return "0.00%";
  }

  const score =
    ((levelOneClose + levelTwoClose + levelThreeClose + levelFourClose) /
      incidentTotalCount) *
    100;
  return `${score.toFixed(2)}%`;
};

export function dashboardCityChange(
  selectedCities,
  cityList,
  searchedItem,
  setSearchedItem,
  dispatch,
  fetchStoreList,
  userID
) {
  let currentCity;

  // Handle "selectAll" logic
  if (selectedCities.includes("selectAll")) {
    currentCity = cityList.cityInfos?.map((item) => item.cityId) || [];
  } else {
    currentCity = selectedCities;
  }

  // Deselect all logic
  const allCitiesSelected = currentCity.length === cityList.cityInfos?.length;
  const currentCitiesEqualSelectedCities =
    searchedItem.currentCity?.length === currentCity.length;
  if (allCitiesSelected && currentCitiesEqualSelectedCities) {
    currentCity = [];
  }

  setSearchedItem({ ...searchedItem, currentCity, storeId: [] });
  if (!currentCity.length) return; //don't make api call as it is deselected
  const payload = {
    userId: userID,
    cityIds: String(currentCity),
    appType: "Web",
  };
  dispatch(fetchStoreList(payload));
}

export function dashboardStoreChange(
  value,
  storeList,
  searchedItem,
  setSearchedItem
) {
  if (value.includes("selectAll")) {
    value = storeList?.map((item) => item.storeId) || [];
  }

  const allStoresSelected = value.length === storeList?.length;
  const currentStoresEqualSelectedStores =
    searchedItem.storeId?.length === value.length;
  if (allStoresSelected && currentStoresEqualSelectedStores) {
    value = [];
  }

  setSearchedItem({
    ...searchedItem,
    storeId: value,
  });
}

export function getCitiesForStores() {
  const cities = JSON.parse(localStorage.getItem("CitiesForStores"));
  if (cities && cities.cityInfos) {
    cities.cityInfos.sort((a, b) => (a.cityName > b.cityName ? 1 : -1));
  }
  return cities;
}
export function getStoresForDashboard (){
  const store =JSON.parse(localStorage.getItem("storeData"));
  return store
}
export function setCurrentCity(cityList, setSearchedItem) {
  if (cityList?.cityInfos?.length) {
    setSearchedItem((prevState) => ({
      ...prevState,
      currentCity: cityList.cityInfos.map((item) => item.cityId),
    }));
  }
}

export function setStoreId(storeList, setSearchedItem) {
  if (storeList?.length) {
    setSearchedItem((prevState) => ({
      ...prevState,
      storeId: storeList.map((item) => item.storeId),
    }));
  }
}

export function setStoreIdToString(initialStoreIdToString, storeIdToString) {
  if (initialStoreIdToString.current === "") {
    initialStoreIdToString.current = storeIdToString;
  }
}
